import styled from 'styled-components';

import { StyledBlockRenderer as DefaultStyledBlockRenderer } from './loyalty-offers.styled.default';

export * from './loyalty-offers.styled.default';

export const StyledBlockRenderer = styled(DefaultStyledBlockRenderer)`
  color: ${Styles.color.grey.three};
`;
